import { useState, useCallback } from "react";
import { syncMercadoPagoPayment, listCheckoutSessions } from "../../../../services/platform_admin_service";

const usePlatformMercadoPago = () => {
    const [sessions, setSessions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [syncing, setSyncing] = useState(false);
    const [syncResult, setSyncResult] = useState(null);
    const [error, setError] = useState(null);

    const loadSessions = useCallback(async (filters = {}) => {
        try {
            setLoading(true);
            const result = await listCheckoutSessions({ page: 1, pageSize: 50, filters });
            setSessions(result.items || []);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, []);

    const syncPayment = useCallback(async (paymentId) => {
        try {
            setSyncing(true);
            setSyncResult(null);
            setError(null);
            const result = await syncMercadoPagoPayment(paymentId);
            setSyncResult(result);
            return result;
        } catch (err) {
            setError(err.message || "Erro ao sincronizar pagamento.");
            return null;
        } finally {
            setSyncing(false);
        }
    }, []);

    return { sessions, loading, syncing, syncResult, error, loadSessions, syncPayment };
};

export default usePlatformMercadoPago;
